module.exports = __webpack_public_path__ + "static/생수음료-a46c92d1f12908ad19df602bb9144088.jpg";